import { useTranslation } from 'react-i18next';

export const useErrorsMap = () => {
  const { t } = useTranslation();

  return new Map<string, string>([
    ['WALLET_NOT_LINKED', t('errorsContent.error_wallet_not_linked')],
    ['WALLET_ALREADY_MAIN', t('errorsContent.error_wallet_already_main')],
    ['WALLET_ALREADY_LINKED', t('errorsContent.error_wallet_already_linked')],
    ['INVALID_WALLET_ADDRESS', t('errorsContent.error_invalid_wallet_address')],
    ['SIGNED_MESSAGE_NOT_FOUND', t('errorsContent.error_signed_message_not_found')],
    ['SIGNATURE_INCORRECT', t('errorsContent.error_signature_incorrect')],
    ['ACCOUNT_CANT_UNLINK_LAST_SOCIAL', t('errorsContent.error_account_cant_unlink_last_social')],
    ['TWITTER_NOT_LINKED', t('errorsContent.error_twitter_not_linked')],
    ['DISCORD_NOT_LINKED', t('errorsContent.error_discord_not_linked')],
    ['RGP_CANNOT_USE_YOUR_OWN_CODE', t('errorsContent.error_rpg_cannot_user_your_own_code')],
    ['RGP_INVALID_OPERATION_FOR_STATE', t('errorsContent.error_rpg_invalid_operation_for_state')],
    ['RGP_WRONG_USER_FOR_THIS_REWARD', t('errorsContent.error_rpg_wrong_user_for_this_reward')],
    ['RGP_TWITTER_NOT_LINKED', t('errorsContent.error_rpg_twitter_not_linked')],
    ['RGP_WALLET_NOT_LINKED', t('errorsContent.error_rpg_wallet_not_linked')],
    ['MAX_LOOTBOX_OPENED', t('errorsContent.error_max_lootbox_opened')],
    ['WALLET_CONNECTED', t('errorsContent.error_wallet_connected')],
    ['WRONG_NETWORK', t('errorsContent.error_wrong_network')],
    ['CANNOT_UNLINK_LAST_WALLET', t('errorsContent.error_cannot_unlink_last_wallet')],
    ['USERNAME_INCORRECT', t('errorsContent.error_username_incorrect')],
    ['TERMS_NOT_SIGNED', t('errorsContent.error_terms_not_signed')],
    ['AGE_VERIFICATION_ERROR', t('errorsContent.error_age_verification_error')],
  ]);
};
